import Territory from '@/services/api/territory';

export default {
  namespaced: true,
  state: {
    territory: [],
    managementGroup: {},
  },
  getters: {
    territory: state => state.territory,
  },
  mutations: {
    setTerritory: (state, payload) => {
      state.territory = payload;
    },
  },
  actions: {
    getTerritory (state, options = {}) {
      return new Promise((resolve, reject) => {
        Territory.getTerritory(options)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    createTerritory (state, params) {
      return new Promise((resolve, reject) => {
        Territory.createTerritory({ ...params })
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    deleteTerritory (state, id) {
      return new Promise((resolve, reject) => {
        Territory.deleteTerritory(id)
          .then((response) => {
            resolve(response);
          })
          .catch(error => reject(error));
      });
    },
  },
};
